import Vue from 'vue';

Vue.prototype.http = async function ({ cmd, type, input, edit, loading, success, error, complete, ...arg }) {
  let self = this;
  // 未登录
  if (!window.localStorage.sessionId && !window.localStorage.users) {
    window.location.replace(window.location.href.split('/#/')[0] + '/login.html');
    return;
  }
  addLoading(loading);
  if (!edit) {
    for (let key in input) {
      if ((/^\s*$/).test(input[key])) {
        input[key] = undefined
      }
    }
  }

  let http = await ajax();
  let result = responseHandler(http);
  reduceLoading();
  return result;

  async function ajax() {
    let _http;
    await new Promise(resolve => {
      const http = new XMLHttpRequest();
      http.onreadystatechange = function () {
        if (http.readyState === 4) {
          _http = http;
          resolve();
        }
      };
      let url = window.CONFIG.HOST + cmd + '.htm';
      if (!input) {
        input = {};
      }
      // formData 特殊处理
      if (input instanceof FormData) {
        http.open('POST', url.replace(/\{.+\}/, arg.id), true);
        window.localStorage.sessionId && http.setRequestHeader('sessionId', window.localStorage.sessionId);
        // http.setRequestHeader('Content-type', 'application/x-www-form-urlencode')
        http.send(input);
      } else {
        http.open('POST', url.replace(/\{.+\}/, arg.id), true);
        window.localStorage.sessionId && http.setRequestHeader('sessionId', window.localStorage.sessionId);
        http.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
        // 去掉字符串前后两端空格
        if (Object.keys(input).length) {
          for (let o in input) {
            if (typeof input[o] == 'string') {
              input[o] = (input[o]).trim();
            }
          }
        }
        http.send(JSON.stringify(input));
      }
    });
    return _http;
  }

  function responseHandler(http) {
    if (!http.responseText) {
      return { code: 'failed', msg: '请求无响应' };
    }
    // 这是请求返回的数据内容
    let res = JSON.parse(http.responseText);
    if (http.status === 200) {
      if (res.code === '1' && !location.href.includes('login')) {
        $(window).trigger('sessionFail');
        Vue.prototype.$confirm('您的账号在别处登录或您已登录超时，请重新登录', '提示', {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        }).then(async () => {
          // location.href = '/#/login'
          window.location.replace(window.location.href.split('/#/')[0] + '/login.html');
        });
        return;
      } else if (res.code === '0') { // 数值保留位数规范
        if (_.get(res, 'data.rows')) {
          window.utils.toFixed(res.data.rows);
        }
        if (_.get(res, 'data.carData')) {
          window.utils.toFixed(res.data.carData);
        }
        window.utils.toFixed(res.data);
        // 排除-1,由具体逻辑判断
      } else {
        let msg = res.message;
        Vue.prototype.$message.error(msg || '网络错误');
      }
      success && success.call(self, res);
    } else {
      if (error) {
        error.call(self, res);
      } else {
        throw new Error(res.message);
      }
    }
    complete && complete.call(self, res);
    return res;
  }
};
// 兼容旧打逃代码
Vue.prototype.api = function (cmd, input, otherOption) {
  return new Promise((resolve) => {
    Vue.prototype.http.call(this, {
      cmd, input, ...otherOption, success(res) {
        resolve(res);
      }
    });
  });
};
let loadingNum = 0;
let loadingTimeout;
let loading;
let loadingTimes = 0;

function addLoading(target) {
  loadingNum++;
  if (loadingTimeout) return;
  loadingTimeout = setTimeout(() => {
    // loading了 n 次了, 友情提示一下
    // 第一次 loading 2次, 提示一下
    // 之后每 loading 5次, 提示一下
    loadingTimes++;
    if (loadingTimes === 2) {
      Vue.prototype.$message.warning('您的网络比较差, 操作响应时间会比较长, 请耐心等候');
      loadingTimes = -3;
    }
    // let target = document.querySelector('.title-bar-text .icon')
    if (target) {
      loading = Vue.prototype.$loading({
        target: target,
        spinner: 'el-icon-loading',
        background: '#f7f8f9',
      });
    }
    // else {
    //   loading = Vue.prototype.$loading({
    //     target: document.body,
    //     spinner: 'el-icon-loading',
    //     text: '正在获取数据',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })
    // }

  }, 1000);
}

function reduceLoading() {
  loadingNum--;
  if (loadingNum <= 0) {
    clearTimeout(loadingTimeout);
    loadingTimeout = loadingNum = 0;
    if (loading) {
      loading.close();
      loading = null;
    }
  }
}

// 过滤空字符串为 undefined
function removeEmpty(obj) {
  if (obj instanceof Array) {
    obj.forEach(removeEmpty);
  } else {
    Object.keys(obj).forEach(key => {
      if (obj[key] === '') {
        obj[key] = undefined;
      }
    });
  }
}
